/**
 * 模块名称: 总/分公司设置
 * @author zhuyan@372163.com
 * @Date: 2025-12-15 09:46:30
 */
import React, { useState, useEffect } from 'react'
import { Modal, Button, Icon, message } from 'antd'
import api from '@/api'
import './assets/companysetting.scss'

const CompanyTypeSetting = ({ visible, onCancel }) => {
    const [allCompanies, setAllCompanies] = useState([])
    const [headCompanies, setHeadCompanies] = useState([])
    const [branchCompanies, setBranchCompanies] = useState([])
    const [selectedCompany, setSelectedCompany] = useState(null)

    useEffect(() => {
        if (visible) {
            setSelectedCompany(null)
            fetchCompanies()
        }
    }, [visible])

    const fetchCompanies = () => {
        api.getTypeCompanyList().then(res => {
            const all = res || []
            const heads = all.filter(c => c.type === 'head')
            const branches = all.filter(c => c.type === 'branch')
            setAllCompanies(all)
            setHeadCompanies(heads)
            setBranchCompanies(branches)
        })
    }

    const handleSelectCompany = (company) => {
        if (isCompanyCategorized(company)) return
        setSelectedCompany(company)
    }

    const isCompanyCategorized = (company) => {
        return headCompanies.some(c => c.id === company.id) || branchCompanies.some(c => c.id === company.id)
    }

    const moveTo = (type) => {
        if (!selectedCompany) return

        api.setCompanyType({ corpId: selectedCompany.id, type }).then(() => {
            message.success('设置成功')
            fetchCompanies()
            setSelectedCompany(null)
        })
    }

    const removeFrom = (company, type) => {
        api.setCompanyType({ corpId: company.id, type: '' }).then(() => {
            message.success('取消成功')
            fetchCompanies()
        })
    }

    return (
        <Modal
            title="总/分公司设置"
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width={800}
            destroyOnClose
        >
            <div className="company-type-setting">
                <div className="company-list-container">
                    <h3>所有公司主体</h3>
                    <div className="company-list">
                        {allCompanies.map(company => (
                            <div
                                key={company.id}
                                className={`company-item ${isCompanyCategorized(company) ? 'disabled' : ''
                                    } ${selectedCompany && selectedCompany.id === company.id ? 'selected' : ''}`}
                                onClick={() => handleSelectCompany(company)}
                            >
                                {company.name}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="arrow-buttons">
                    <Button onClick={() => moveTo('head')} disabled={!selectedCompany}>
                        <Icon type="arrow-right" />
                    </Button>
                    <Button onClick={() => moveTo('branch')} disabled={!selectedCompany}>
                        <Icon type="arrow-right" />
                    </Button>
                </div>
                <div className="selected-companies-container">
                    <div className="company-list-container">
                        <h3>总公司主体</h3>
                        <div className="company-list">
                            {headCompanies.map(company => (
                                <div key={company.id} className="company-item">
                                    {company.name}
                                    <Icon type="close" onClick={() => removeFrom(company, 'head')} />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="company-list-container">
                        <h3>分公司主体</h3>
                        <div className="company-list">
                            {branchCompanies.map(company => (
                                <div key={company.id} className="company-item">
                                    {company.name}
                                    <Icon type="close" onClick={() => removeFrom(company, 'branch')} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default CompanyTypeSetting